/* SACRA pop-ups
   popA  welcome. Opens a few seconds into the visit on every page, except the quiz page and the QR ritual page.
         Step 1 email, step 2 the code (SACRA10, applied to the bag), step 3 the optional three-tap ritual.
         The quiz answers go to the Klaviyo profile so the welcome email can carry the ritual.
   Tab   closed without signing up: a small tab on the left brings popA back.
   popB  the barrier game, opened from [data-pop="popB"]. */
(function(){
  var CODE='SACRA10';
  var OPEN_AT=7000;      /* ms after the page started loading */
  var SNOOZE_DAYS=3;     /* after a close, no automatic opening for this long; the tab stays */
  var lastFocus=null, openId=null, quizA=null;

  function el(id){return document.getElementById(id)}
  function ls(k,v){ try{ if(v===undefined) return localStorage.getItem(k); if(v===null) localStorage.removeItem(k); else localStorage.setItem(k,v); }catch(e){ return null; } }
  function ss(k,v){ try{ if(v===undefined) return sessionStorage.getItem(k); if(v===null) sessionStorage.removeItem(k); else sessionStorage.setItem(k,v); }catch(e){ return null; } }
  function publish(name,data){ if(window.Shopify&&Shopify.analytics) try{ Shopify.analytics.publish(name,data||{}) }catch(e){} }
  function anyOpen(){ return !!openId }
  /* Not now: another layer is open, the cookie banner is still up, the visitor is typing, or has just tapped Add to bag */
  var busyUntil=0;
  function consentUp(){ var b=document.getElementById('shopify-pc__banner'), q=document.getElementById('shopify-pc__prefs'); return !!((b&&b.offsetHeight>0)||(q&&q.offsetHeight>0)); }
  function typing(){ var a=document.activeElement; return !!(a&&/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)&&!a.closest('#popA')); }
  function blocked(){ return anyOpen() || !!document.querySelector('#SacraDrawer.is-open') || document.body.classList.contains('menu-open') || consentUp() || typing() || Date.now()<busyUntil; }
  document.addEventListener('click',function(e){ var t=e.target.closest&&e.target.closest('button,a,[data-quick-add]'); if(t&&(t.matches('[data-quick-add],[name="add"]')||t.closest('form[action*="/cart/add"]')||/add to (bag|cart)/i.test(t.textContent||''))) busyUntil=Date.now()+5000; },true);

  /* ---------- who should not see the welcome offer ---------- */
  function knownToKlaviyo(){
    try{
      var m=document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/); if(!m) return false;
      var j=JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(j&&(j.$exchange_id||j.$email));
    }catch(e){ return false; }
  }
  function fromEmail(){
    try{ var q=new URLSearchParams(location.search); return /klaviyo|email/i.test((q.get('utm_source')||'')+' '+(q.get('utm_medium')||'')) || !!q.get('_kx'); }catch(e){ return false; }
  }
  function subscribed(){
    if(ls('sacra_sub')==='1') return true;
    var a=el('popA'); if(a&&a.dataset.skip==='1') return true;
    if(knownToKlaviyo()||fromEmail()){ ls('sacra_sub','1'); return true; }
    return false;
  }
  function excluded(){
    if(window.Shopify&&Shopify.designMode) return true;
    if(el('quizPage')) return true;
    var p=location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i,'');
    if(/^\/pages\/ritual\/?$/.test(p)) return true;
    if(/^\/(account|password|challenge)/.test(p)) return true;
    if(document.querySelector('[data-popup-none]')) return true;
    return false;
  }
  function snoozed(){ var t=+(ls('sacra_pop_snooze')||0); return !!t && (Date.now()-t) < SNOOZE_DAYS*864e5; }
  /* Pages that ask for it (the advertorial headline sets data-popup-tab) never open the pop-up by themselves.
     The tab appears once the element named in the attribute (e.g. #offer) reaches the screen, or straight away if none. */
  function tabOnly(){ return !!document.querySelector('[data-popup-tab]'); }
  function tabWhenReached(){
    var f=document.querySelector('[data-popup-tab]'), sel=f?f.getAttribute('data-popup-tab'):'', t=null;
    try{ t=sel?document.querySelector(sel):null; }catch(e){ t=null; }
    if(!t){ setTimeout(showTab,1200); return; }
    var done=false;
    function chk(){ if(done) return; if(t.getBoundingClientRect().top<window.innerHeight){ done=true; window.removeEventListener('scroll',chk); showTab(); } }
    window.addEventListener('scroll',chk,{passive:true}); chk();
  }

  /* First-touch UTMs for this session, so a signup on the second page still carries them */
  (function(){ try{ var q=new URLSearchParams(location.search); ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function(k){ var v=q.get(k); if(v&&!ss('sacra_'+k)) ss('sacra_'+k,v.slice(0,150)); }); }catch(e){} })();
  function signupProps(source){
    var p={signup_source:source, signup_page:location.pathname.slice(0,150), welcome_code:CODE};
    ['utm_source','utm_medium','utm_campaign','utm_content'].forEach(function(k){ var v=ss('sacra_'+k); if(v) p[k]=v; });
    return p;
  }

  /* ---------- Klaviyo ---------- */
  function subscribe(email,source,props){
    ls('sacra_sub','1'); ls('sacra_pop_snooze',null); ss('sacra_email',email);
    if(window.sacraSubscribe) return window.sacraSubscribe(email,source,Object.assign(signupProps(source),props||{}));
  }
  /* Adds properties to an existing profile without touching the subscription */
  function updateProfile(email,props){
    var k=window.SACRA_KLAVIYO||{}; if(!k.company||!email) return;
    try{
      fetch('https://a.klaviyo.com/client/profiles/?company_id='+encodeURIComponent(k.company),{method:'POST',headers:{'Content-Type':'application/json',revision:'2024-10-15'},
        body:JSON.stringify({data:{type:'profile',attributes:{email:email,properties:props}}})}).catch(function(){});
    }catch(e){}
  }
  window.sacraProfile=updateProfile;

  /* ---------- the tab ---------- */
  var tab=el('sacTab');
  function showTab(){
    if(!tab||subscribed()||excluded()||ss('sacra_tab_x')==='1') return;
    tab.hidden=false; requestAnimationFrame(function(){ requestAnimationFrame(function(){ tab.classList.add('show'); }); });
  }
  function hideTab(){ if(!tab) return; tab.classList.remove('show'); setTimeout(function(){ if(!tab.classList.contains('show')) tab.hidden=true; },380); }

  /* ---------- open / close ---------- */
  function pane(name){
    var o=el('popA'); if(!o) return;
    o.querySelectorAll('.wel-pane').forEach(function(p){ p.classList.toggle('on',p.dataset.w===name); });
    var media=o.querySelector('[data-w-media]'); if(media) media.hidden=(name!=='email');
    var eb=o.querySelector('[data-w-eyebrow]'); if(eb) eb.textContent=(name==='email')?'Welcome to SACRA':(name==='code'?'You’re in':'Your ritual');
    var sh=o.querySelector('.sheet'); if(sh) sh.scrollTop=0;
  }
  function open(id,step){
    if(openId===id){ if(id==='popA'&&step) pane(step); return; }
    if(openId) closeNow(openId,true);
    var o=el(id); if(!o) return;
    lastFocus=document.activeElement;
    if(id==='popA'){
      var img=o.querySelector('[data-w-media] img'); if(img&&!img.getAttribute('src')&&img.dataset.src) img.src=img.dataset.src;
      if(step==='quiz') startQuiz(); else pane(step||(ls('sacra_sub')==='1'&&ss('sacra_email')?'code':'email'));
      hideTab();
    }
    o.hidden=false; openId=id;
    document.body.style.overflow='hidden';
    requestAnimationFrame(function(){o.classList.add('open')});
    if(id==='popB') game.reset();
    publish('popup_open',{popup:id,step:step||''});
    /* Focus: the email field with a mouse, the sheet itself on touch screens (no keyboard jumping up) */
    var f=null;
    if(id==='popA'){ var fine=window.matchMedia&&matchMedia('(pointer:fine)').matches; f=(fine&&o.querySelector('.wel-pane.on input'))||o.querySelector('.sheet'); }
    else f=o.querySelector('.pane.on button, .close');
    if(f) setTimeout(function(){ try{f.focus({preventScroll:true})}catch(e){f.focus()} },80);
  }
  function afterClose(id){ if(id==='popA'&&!subscribed()){ ls('sacra_pop_snooze',String(Date.now())); showTab(); } }
  function closeNow(id,switching){ var o=el(id); if(!o) return; o.classList.remove('open'); o.hidden=true; if(openId===id) openId=null; document.body.style.overflow=''; if(id==='popB') game.stop(); if(!switching) afterClose(id); }
  function close(id){
    var o=el(id); if(!o||o.hidden) return;
    o.classList.remove('open');
    if(id==='popB') game.stop();
    setTimeout(function(){ o.hidden=true; if(openId===id) openId=null; document.body.style.overflow=''; if(lastFocus&&lastFocus.focus) try{lastFocus.focus({preventScroll:true})}catch(e){} afterClose(id); },350);
    publish('popup_close',{popup:id});
  }

  /* ---------- welcome steps ---------- */
  function applyCode(){
    try{
      fetch('/discount/'+encodeURIComponent(CODE)+'?redirect=%2Fcart.js',{credentials:'same-origin'}).then(function(r){
        var n=el('popA')&&el('popA').querySelector('[data-w-note]');
        if(n&&r.ok) n.textContent='Already applied to your bag on this device. One use per customer. A copy is on its way to your inbox.';
      }).catch(function(){});
    }catch(e){}
  }
  function copyCode(btn){
    function ok(){ btn.textContent='Copied'; setTimeout(function(){btn.textContent='Copy'},1800); if(window.toast) window.toast('Code '+CODE+' copied'); }
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(CODE).then(ok,function(){}); } else ok();
  }
  function startQuiz(){
    pane('quiz');
    if(!window.SacraQuiz) return;
    var email=ss('sacra_email')||'';
    if(!quizA){
      quizA=SacraQuiz.mount(el('quizA'),{intro:false,code:CODE,showCode:false,email:email,focus:true,
        onResult:function(state,items,props){ if(email) updateProfile(email,Object.assign({ritual_source:'popup'},props)); }});
    }
    if(window.hydrateImgs) window.hydrateImgs(el('quizA'));
  }

  document.addEventListener('click',function(e){
    var c=e.target.closest('[data-close]'); if(c){ close(c.dataset.close); return; }
    var p=e.target.closest('[data-pop]'); if(p){ e.preventDefault(); open(p.dataset.pop,p.dataset.popStep); return; }
    if(e.target.classList&&e.target.classList.contains('sac-overlay')){ close(e.target.id); return; }
    if(e.target.closest('[data-tab-open]')){ open('popA','email'); publish('popup_tab_open',{}); return; }
    if(e.target.closest('[data-tab-x]')){ ss('sacra_tab_x','1'); hideTab(); return; }
    if(e.target.closest('[data-w-copy]')){ copyCode(e.target.closest('[data-w-copy]')); return; }
    if(e.target.closest('[data-w-quiz]')){ startQuiz(); return; }
    var a=e.target.closest('.sac-overlay a[href]'); if(a&&openId) close(openId);
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&openId) close(openId); });

  document.addEventListener('submit',function(e){
    var f=e.target;
    /* Step 1 of the welcome pop-up */
    if(f.matches('form[data-welcome]')){
      e.preventDefault();
      var i=f.querySelector('input[type=email]'), err=f.querySelector('.wel-err'), v=(i.value||'').trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){ i.setAttribute('aria-invalid','true'); if(err) err.hidden=false; i.focus(); return; }
      i.removeAttribute('aria-invalid'); if(err) err.hidden=true;
      subscribe(v,'popup');
      applyCode();
      hideTab();
      i.value='';
      pane('code');
      publish('email_signup',{source:'popup',page:location.pathname});
      return;
    }
    /* Ritual emails from the quiz page, the quiz without a known email, and the game */
    if(f.matches('form[data-email]')){
      e.preventDefault(); var inp=f.querySelector('input'); var val=(inp.value||'').trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)){inp.focus();inp.setAttribute('aria-invalid','true');return}
      inp.removeAttribute('aria-invalid'); inp.value='';
      var props={}; try{ props=f.dataset.props?JSON.parse(f.dataset.props):{}; }catch(x){}
      subscribe(val,f.dataset.email==='plan'?'quiz-plan':'quiz-result',props);
      hideTab();
      try{ f.dispatchEvent(new CustomEvent('sacra:subscribed',{bubbles:true,detail:{email:val}})); }catch(x){}
      if(window.toast) window.toast(f.dataset.email==='plan'?'28-day ritual sent to '+val:'Your ritual is on its way to '+val);
      if(openId) close(openId);
      return;
    }
    /* The footer newsletter (handled in sacra26-app.js): just remember the visitor signed up */
    if(f.matches('form[data-nl]')){ var n=f.querySelector('input[type=email]'); if(n&&/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((n.value||'').trim())){ ls('sacra_sub','1'); hideTab(); } }
  },true);

  /* ---------- Pop-up B: Rebuild your barrier ---------- */
  var game=(function(){
    var canvas=el('wall'); if(!canvas) return {reset:function(){},stop:function(){},start:function(){}};
    var ctx=canvas.getContext('2d');
    var W=464,H=248,m=8,bh=40,bw=68,rows=5,dpr=Math.min(2,window.devicePixelRatio||1);
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var bricks=[],flying=[],raf=null,running=false,t0=0,last=0,spawnAt=0,sumInt=0,samples=0;
    var LABELS=['SUN','TRAVEL','EXERCISE','CLIMATE'];
    var C={mortar:'#C96947',brick:'#E4D6C3',brickPale:'#F2EAE1',gone:'#EDE3D7'};
    canvas.width=W*dpr; canvas.height=H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0);
    function build(){
      bricks=[];
      for(var r=0;r<rows;r++){
        var y=m+r*(bh+m), off=(r%2)?-(bw+m)/2:0;
        for(var i=0;i<8;i++){
          var x=m+off+i*(bw+m), x0=Math.max(m,x), x1=Math.min(W-m,x+bw);
          if(x1-x0<18) continue;
          bricks.push({x:x0,y:y,w:x1-x0,h:bh,sealed:true,targeted:false,flash:0,drops:[]});
        }
      }
    }
    function gpane(name){document.querySelectorAll('#popB .pane').forEach(function(p){p.classList.toggle('on',p.dataset.g===name)})}
    function reset(){stop(); build(); flying=[]; gpane('intro'); draw();}
    function start(){ build(); flying=[]; sumInt=0; samples=0; running=true; t0=performance.now(); last=t0; spawnAt=t0+700; gpane('play'); loop(t0); }
    function stop(){running=false; if(raf) cancelAnimationFrame(raf); raf=null;}
    function integrity(){var s=0; bricks.forEach(function(b){if(b.sealed)s++}); return s/bricks.length}
    function spawn(){
      var pool=bricks.filter(function(b){return b.sealed&&!b.targeted}); if(!pool.length) return;
      var b=pool[Math.floor(Math.random()*pool.length)]; b.targeted=true;
      flying.push({label:LABELS[Math.floor(Math.random()*LABELS.length)],x:b.x+b.w/2,ty:b.y+b.h/2,t:reduce?1:0,b:b});
    }
    function erode(b){ b.sealed=false; b.targeted=false; for(var i=0;i<3;i++) b.drops.push({x:b.x+8+Math.random()*(b.w-16),y:b.y+4,v:14+Math.random()*16,a:1}); }
    function loop(now){
      if(!running) return;
      var dt=Math.min(50,now-last); last=now; var el_=now-t0; var progress=Math.min(1,el_/20000);
      var interval=1100-520*progress;
      if(now>=spawnAt){spawn(); spawnAt=now+interval;}
      flying.forEach(function(f){ f.t+=dt/620; if(f.t>=1&&!f.done){f.done=true; erode(f.b);} });
      flying=flying.filter(function(f){return f.t<1.35});
      bricks.forEach(function(b){ if(b.flash>0)b.flash=Math.max(0,b.flash-dt/380); b.drops.forEach(function(d){d.y-=d.v*dt/1000; d.a-=dt/1400}); b.drops=b.drops.filter(function(d){return d.a>0}); });
      var integ=integrity(); sumInt+=integ; samples++;
      el('gInt').textContent=Math.round(integ*100)+'%';
      el('gTime').textContent=Math.max(0,Math.ceil((20000-el_)/1000));
      el('gBar').style.transform='scaleX('+(1-progress)+')';
      draw();
      if(el_>=20000){ finish(); return; }
      raf=requestAnimationFrame(loop);
    }
    function draw(){
      ctx.clearRect(0,0,W,H);
      ctx.fillStyle=C.mortar; ctx.fillRect(m/2,m/2,W-m,H-m);
      bricks.forEach(function(b){ if(!b.sealed){ ctx.fillStyle=C.gone; var x0=Math.max(m/2,b.x-m),y0=Math.max(m/2,b.y-m); ctx.fillRect(x0,y0,Math.min(W-m/2,b.x+b.w+m)-x0,Math.min(H-m/2,b.y+b.h+m)-y0); } });
      bricks.forEach(function(b){
        ctx.fillStyle=b.sealed?C.brick:C.brickPale; ctx.fillRect(b.x,b.y,b.w,b.h);
        if(b.flash>0){ ctx.fillStyle='rgba(201,105,71,'+(0.55*b.flash)+')'; ctx.fillRect(b.x,b.y,b.w,b.h); }
        b.drops.forEach(function(d){ ctx.fillStyle='rgba(42,26,18,'+(0.35*d.a)+')'; ctx.beginPath(); ctx.arc(d.x,d.y,2.2,0,Math.PI*2); ctx.fill(); });
      });
      ctx.font='500 10px Jost, Futura, "Century Gothic", sans-serif'; ctx.textAlign='center'; ctx.textBaseline='middle';
      flying.forEach(function(f){
        var e=f.t<1?(f.t*f.t):1; var y=-14+(f.ty+14)*e; var a=f.t<1?1:Math.max(0,1-(f.t-1)/0.35);
        ctx.fillStyle='rgba(42,26,18,'+a+')'; var w=ctx.measureText(f.label).width+18; ctx.fillRect(f.x-w/2,y-9,w,18);
        ctx.fillStyle='rgba(242,234,225,'+a+')'; ctx.fillText(f.label.split('').join(String.fromCharCode(8202)),f.x,y+0.5);
      });
    }
    function tap(e){
      if(!running) return;
      var r=canvas.getBoundingClientRect(); var px=(e.clientX-r.left)*W/r.width, py=(e.clientY-r.top)*H/r.height;
      for(var i=0;i<bricks.length;i++){ var b=bricks[i];
        if(px>=b.x-m/2&&px<=b.x+b.w+m/2&&py>=b.y-m/2&&py<=b.y+b.h+m/2){ if(!b.sealed){b.sealed=true;b.flash=1;b.drops=[];} break; }
      }
    }
    canvas.addEventListener('pointerdown',function(e){e.preventDefault();tap(e)});
    function finish(){
      running=false; if(raf) cancelAnimationFrame(raf); raf=null;
      var score=Math.round((sumInt/Math.max(1,samples))*100);
      var tier,head,copy;
      if(score>=85){tier='Barrier rebuilt';head='Quick hands.';copy='Your skin needs the same reflex every evening: lipids back before the water leaves. That is the serum’s whole job.';}
      else if(score>=55){tier='Half rescued';head='That is most skin after a summer.';copy='Some mortar back, some still missing. Tightness by midday is the sign. The serum finishes what your fingertips started.';}
      else{tier='Depleted';head='That is a flight, a run and a beach day, without help.';copy='Water escapes through a wall like this one all night long. Here is the rescue, in the order to use it.';}
      el('gTier').textContent=tier; el('gScore').textContent=score+'%'; el('gHead').textContent=head; el('gCopy').textContent=copy;
      gpane('end'); el('popB').querySelector('.sheet').scrollTop=0;
      publish('game_complete',{score:score,tier:tier});
    }
    document.querySelector('[data-g-start]').addEventListener('click',start);
    document.querySelector('[data-g-again]').addEventListener('click',start);
    document.querySelector('[data-g-skip]').addEventListener('click',function(){close('popB'); setTimeout(function(){open('popA',ls('sacra_sub')==='1'?'quiz':'email')},380)});
    build(); draw();
    return {reset:reset,stop:stop,start:start};
  })();

  /* ---------- automatic opening ---------- */
  /* If something was in the way, wait a moment after it clears so the pop-up is not a second interruption */
  function auto(tries,settled){
    if(subscribed()||excluded()) return;
    if(snoozed()){ showTab(); return; }
    if(blocked()){ if((tries||0)<20) setTimeout(function(){auto((tries||0)+1,false)},2000); return; }
    if(tries&&!settled){ setTimeout(function(){auto(tries,true)},2500); return; }
    open('popA','email');
  }
  if(!subscribed()&&!excluded()){
    if(tabOnly()){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',tabWhenReached); else tabWhenReached(); }
    else if(snoozed()) setTimeout(showTab,1200);
    else { var since=(window.performance&&performance.now)?performance.now():0; setTimeout(auto,Math.max(1200,OPEN_AT-since)); }
  }

  window.sacraPopups={open:open,close:close,showTab:showTab};
})();
